import { Button, ButtonProps } from '@/components/ui/button';
import { cn } from '@/utils/shadcn';
interface RainbowButtonProps extends ButtonProps {}

export function RainbowButton({
  children,
  className,
  disabled,
  ...props
}: RainbowButtonProps) {
  return (
    <Button
      className={cn(
        'group relative inline-flex h-11 cursor-pointer items-center justify-center border-0 bg-[length:200%] px-8 py-2 font-medium text-primary-foreground transition-colors [background-clip:padding-box,border-box,border-box] [background-origin:border-box] [border:calc(0.08*1rem)_solid_transparent] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50',

        // Conditionally apply rainbow animation
        !disabled && 'animate-rainbow',

        // Updated glow effect colors
        !disabled &&
          'before:absolute before:bottom-[-20%] before:left-1/2 before:z-0 before:h-1/5 before:w-3/5 before:-translate-x-1/2 before:animate-rainbow before:bg-[linear-gradient(90deg,#01C3C3,#F59D0F,#F55866,#01C3C3)] before:bg-[length:200%] before:[filter:blur(calc(0.8*1rem))]',

        // Updated main button colors
        'bg-[linear-gradient(#121213,#121213),linear-gradient(#121213_50%,rgba(18,18,19,0.6)_80%,rgba(18,18,19,0)),linear-gradient(90deg,#01C3C3,#F59D0F,#F55866,#01C3C3)] text-white',

        className,
      )}
      disabled={disabled}
      {...props}>
      {children}
    </Button>
  );
}
